import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { Globe, List, SignOut, User } from "@phosphor-icons/react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { NotificationBell } from "./NotificationBell";

export const Header = () => {
  const { user, logout } = useAuth();
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const langs = [["nl", "NL"], ["de", "DE"], ["en", "EN"]];

  const NavLinks = () => (
    <>
      <Link data-testid="nav-marketplace" to="/jobs" className="text-sm font-medium text-zinc-700 hover:text-[#E11D2A] transition-colors">{t("nav_marketplace")}</Link>
      {user && <Link data-testid="nav-dashboard" to="/dashboard" className="text-sm font-medium text-zinc-700 hover:text-[#E11D2A] transition-colors">{t("nav_dashboard")}</Link>}
      {user && <Link data-testid="nav-messages" to="/messages" className="text-sm font-medium text-zinc-700 hover:text-[#E11D2A] transition-colors">{t("nav_messages")}</Link>}
      {user && user.role === "company" && <Link data-testid="nav-billing" to="/billing" className="text-sm font-medium text-zinc-700 hover:text-[#E11D2A] transition-colors">{t("nav_billing")}</Link>}
      {user && user.is_admin && <Link data-testid="nav-admin" to="/admin" className="text-sm font-bold text-[#E11D2A] hover:text-[#B0121F] transition-colors">{t("nav_admin")}</Link>}
    </>
  );

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0A0D13]/85 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <img src="/guardlink-logo.jpg" alt="GuardLink" className="h-11 w-auto rounded-md" />
        </Link>

        <nav className="hidden md:flex items-center gap-7"><NavLinks /></nav>

        <div className="flex items-center gap-3">
          <DropdownMenu>
            <DropdownMenuTrigger data-testid="lang-switcher" className="flex items-center gap-1 text-sm font-semibold text-zinc-600 hover:text-[#E11D2A] transition-colors">
              <Globe size={18} /> {lang.toUpperCase()}
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {langs.map(([code, label]) => (
                <DropdownMenuItem key={code} data-testid={`lang-${code}`} onClick={() => setLang(code)}>{label}</DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          {user && <NotificationBell />}

          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger data-testid="user-menu" className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-zinc-200 hover:bg-zinc-50 transition-colors">
                <User size={16} /> <span className="text-sm font-medium max-w-[120px] truncate">{user.name}</span>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem data-testid="menu-profile" onClick={() => navigate("/dashboard")}>{t("nav_dashboard")}</DropdownMenuItem>
                <DropdownMenuItem data-testid="menu-logout" onClick={() => { logout(); navigate("/"); }}>
                  <SignOut size={16} className="mr-2" /> {t("nav_logout")}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <>
              <button data-testid="nav-login" onClick={() => navigate("/login")} className="hidden sm:block text-sm font-semibold text-zinc-700 hover:text-[#E11D2A] transition-colors">{t("nav_login")}</button>
              <button data-testid="nav-register" onClick={() => navigate("/register")} className="bg-[#E11D2A] text-white hover:bg-[#B0121F] text-sm font-semibold rounded-md px-4 py-2 transition-colors">{t("nav_register")}</button>
            </>
          )}

          <button className="md:hidden" data-testid="mobile-menu-btn" onClick={() => setOpen(!open)}><List size={22} /></button>
        </div>
      </div>
      {open && <div className="md:hidden px-5 py-4 flex flex-col gap-4 border-t border-white/10 bg-[#0A0D13]"><NavLinks /></div>}
    </header>
  );
};
